import { CssBaseline } from "@mui/material";
import React, { useEffect } from "react";
import {
  MainContainer,
  MainContent,
} from "../../../components/DataEntry/StyledFields";
// import logo from "../../../images/ne-logo.png";
import MainForm from "./MainForm";
import { getVoucherToCreateEdit } from "./Model";

const EmptyIndUser = {
  identifier: "",
  firstName: "",
  lastName: "",
  email: "",
};

const CreateOrUpdateVoucher = ({
  individualApplication = false,
  voucher = null,
  indUser = EmptyIndUser,
  onExit,
  onClose,
  createMode = true,
}) => {
  useEffect(() => {
    if (!individualApplication) {
      // Redirect to path without the form at the end
    }
  }, [individualApplication]);

  return (
    <React.Fragment>
      <CssBaseline />
      <MainContainer>
        <MainContent>
          {/* <BoxRow>
            <img src={logo} width="100px" alt="logo" />
          </BoxRow> */}
          <MainForm
            individualApplication={individualApplication}
            voucherInitialValues={getVoucherToCreateEdit(individualApplication, indUser, voucher, createMode ? "" : voucher.voucher_detail.identifier)}
            onExit={onExit}
            onClose={onClose}
            createMode={createMode}
          />
        </MainContent>
      </MainContainer>
    </React.Fragment>
  );
};

export default CreateOrUpdateVoucher;
